import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  AppBar,
  Toolbar,
  IconButton
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <AppBar position="static" sx={{ backgroundColor: 'white', color: 'black', boxShadow: 1 }}>
        <Toolbar>
          <IconButton onClick={() => navigate('/')} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            Politique des Cookies - BookingBarber
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0' }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
            Politique des Cookies
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Dernière mise à jour : 13 juin 2025
          </Typography>

          <Box sx={{ '& > *': { mb: 3 } }}>
            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                1. Qu'est-ce qu'un cookie ?
              </Typography>
              <Typography variant="body1" paragraph>
                Un cookie est un petit fichier texte stocké sur votre appareil lorsque vous visitez un site web. 
                Les cookies nous aident à améliorer votre expérience sur BookingBarber.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                2. Types de cookies utilisés
              </Typography>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 2 }}>
                Cookies essentiels
              </Typography>
              <Typography variant="body1" paragraph>
                Ces cookies sont nécessaires au fonctionnement du site. Ils incluent :
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>Cookies d'authentification (maintenir votre session)</li>
                <li>Cookies de sécurité (protection CSRF)</li>
                <li>Cookies de préférences (langue, paramètres d'affichage)</li>
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 2 }}>
                Cookies analytiques
              </Typography>
              <Typography variant="body1" paragraph>
                Ces cookies nous aident à comprendre comment vous utilisez notre site :
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>Google Analytics (analyse du trafic)</li>
                <li>Mesure de performance</li>
                <li>Statistiques d'utilisation</li>
              </Typography>

              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 2 }}>
                Cookies fonctionnels
              </Typography>
              <Typography variant="body1" paragraph>
                Ces cookies améliorent votre expérience :
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>Mémorisation de vos préférences</li>
                <li>Personnalisation de l'interface</li>
                <li>Fonctionnalités de géolocalisation</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                3. Cookies tiers
              </Typography>
              <Typography variant="body1" paragraph>
                Nous utilisons des services tiers qui peuvent placer leurs propres cookies :
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li><strong>Firebase/Google :</strong> Authentification et hébergement</li>
                <li><strong>Stripe :</strong> Traitement des paiements</li>
                <li><strong>Google Maps :</strong> Services de géolocalisation</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                4. Gestion des cookies
              </Typography>
              <Typography variant="body1" paragraph>
                Vous pouvez contrôler les cookies de plusieurs façons :
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>Paramètres de votre navigateur</li>
                <li>Outils de gestion des cookies</li>
                <li>Désactivation des cookies analytiques</li>
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Note :</strong> La désactivation de certains cookies peut affecter le fonctionnement du site.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                5. Durée de conservation
              </Typography>
              <Typography variant="body1" paragraph>
                Les cookies ont différentes durées de vie :
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li><strong>Cookies de session :</strong> Supprimés à la fermeture du navigateur</li>
                <li><strong>Cookies persistants :</strong> Conservés selon leur date d'expiration (généralement 1 à 2 ans)</li>
                <li><strong>Cookies d'authentification :</strong> 30 jours maximum</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                6. Vos droits
              </Typography>
              <Typography variant="body1" paragraph>
                Conformément au RGPD, vous avez le droit de :
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>Être informé de l'utilisation des cookies</li>
                <li>Donner ou retirer votre consentement</li>
                <li>Accéder aux données collectées via les cookies</li>
                <li>Demander la suppression de ces données</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                7. Contact
              </Typography>
              <Typography variant="body1" paragraph>
                Pour toute question concernant notre utilisation des cookies, contactez-nous à : support@omnivers.fr
              </Typography>
              <Typography variant="body1" paragraph>
                Omnivers LTD<br />
                71-75 Shelton Street, Covent Garden<br />
                London, United Kingdom, WC2H 9JQ
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default CookiePolicy;